module.exports = __webpack_public_path__ + "img/Skirt-Front-B8-Db-Fb-Hc-Ia.c3b60f99.png";